import classnames from "classnames";
import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import styles from "./MoreLikeThis.module.scss";

type Props = {
  /**
   * A string representing the product ID.
   */
  productId: string;
  /**
   * A string representing the base path for Edge Side Includes (ESI).
   */
  esiBasepath: string;
};

export const MoreLikeThisUI = ({ productId, esiBasepath }: Props) => {
  const src = `${esiBasepath}/esi/breadcrumbs/more-like-this/${productId}`;

  return (
    <div
      data-testid="more-like-this"
      className={classnames(styles["more-like-this-wrapper"], "esi-wrapper")}
      data-component="MoreLikeThis"
    >
      <ESIInclude src={src} id="more-like-this-breadcrumbs" />
    </div>
  );
};
